import {FormControl, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {ResponsiveRow} from "../../../constants/layout.constants";
import VerticalBarChartsCard from "../../charts/VerticalBarChartCard";
import "dayjs/locale/en-gb";
import {getUtilitiesConsumption} from "../../../services/dashboard.service";
import dayjs from "dayjs";
import {YearPickerInput} from "../../inputs/datePickerInput";
import {useSelector} from "react-redux";

/**
 *
 *
 * REQUIRED PROPS
 *
 * customHeight: string
 * customWidth: string
 *
 *
 */

export default function UtilitiesConsumption({customHeight, customWidth}) {
    const [dataLabels, setDataLabels] = useState([]);
    const [dataset, setDataset] = useState([]);
    const [year, setYear] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const user = useSelector((state) => state.auth.user);
    useEffect(() => {
        setLoading(true);
        getUtilitiesConsumption(year.getFullYear())
            .then((response) => {
                if (response && response.data) {
                    const label = new Set();
                    const set = new Set();
                    // Set the data labels and dataset
                    for (const [key, value] of Object.entries(response.data)) {
                        set.add({
                            datasetLabel: key,
                            datasetData: value,
                        });
                        for (const [key1] of Object.entries(value)) {
                            label.add(key1);
                          }
                      }
                    setDataLabels([...label]);
                    setDataset([...set]);
                }
            }).finally(() => {
            setLoading(false);
        });
    }, [year, user.proxyFacility]);

    return (
        <ResponsiveRow
            sx={{
                flexDirection: "column",
                flexWrap: "nowrap",
                height: {xs: "100%", lg: customHeight},
                width: "100%",
                margin: "10px",
                backgroundColor: "#fff",
                borderRadius: "20px",
            }}
        >
            <ResponsiveRow
                sx={{
                    flexDirection: "row",
                    width: "100%",
                    height: "auto",
                    textAlign: "start",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{width: "75%"}} variant="h5">
                    Utilities Consumption Bill
                </Typography>
                <FormControl sx={{width: {xs: "100%", lg: "25%"}}}>
                    <YearPickerInput
                        componentID="utilitiesConsumptionDate"
                        sx={{width: {xs: "100%", lg: "90%"}, padding: "0 5px"}}
                        labelText="Select Year"
                        disableFuture={true}
                        disablePast={false}
                        value={dayjs(year)}
                        onSelectDate={newDate => setYear(new Date(newDate))}
                    />
                </FormControl>
            </ResponsiveRow>

            <ResponsiveRow
                sx={{
                    height: "80%",
                    width: "100%",
                    flexWrap: "nowrap",
                    flexDirection: "row",
                    alignItem: "center",
                    justifyContent: "center",
                }}
            >

                <VerticalBarChartsCard
                                    dataObj={{
                                        dataLabels: dataLabels,
                                        dataset: dataset,
                                    }}
                                    currentlyLoading={loading}
                                />


            </ResponsiveRow>
            {/* )} */}
        </ResponsiveRow>
    );
}
